import { formatDistance } from 'date-fns';
import { enUS, ro } from 'date-fns/locale';
import { useEffect, useState } from 'react';
import { cn } from '@/utils/utils.ts';
import { useTranslation } from 'react-i18next';

let globalTime = Date.now();
const listeners: Set<() => void> = new Set();
let intervalId: ReturnType<typeof setInterval> | null = null;

const startGlobalTimer = () => {
  if (intervalId) return;
  intervalId = setInterval(() => {
    globalTime = Date.now();
    for (const listener of listeners) listener();
  }, 10000);
};

const stopGlobalTimer = () => {
  if (intervalId && listeners.size === 0) {
    clearInterval(intervalId);
    intervalId = null;
  }
};

const useSharedTime = () => {
  const [, forceUpdate] = useState(0);

  useEffect(() => {
    const listener = () => forceUpdate((n) => n + 1);
    listeners.add(listener);
    startGlobalTimer();

    return () => {
      listeners.delete(listener);
      stopGlobalTimer();
    };
  }, []);

  return globalTime;
};

interface LastUpdateTimestampProps {
  updatedAt?: number;
  className?: string;
}

export const LastUpdateTimestamp = ({ updatedAt, className }: LastUpdateTimestampProps) => {
  const { i18n } = useTranslation();
  const currentTime = useSharedTime();

  return (
    <span className={cn('text-muted-foreground h-4 text-xs', className)}>
      {!updatedAt
        ? '...'
        : formatDistance(updatedAt, currentTime, {
            includeSeconds: true,
            locale: (i18n.language as 'ro' | 'en') === 'ro' ? ro : enUS,
          })}
    </span>
  );
};
